import React, { Component } from 'react';

class LayoutConfigMetadata extends Component {
    render() {
        return (
            <div>
                <h2> Configuração de Layouts </h2>
                <p>
                    Nesta página pode criar, modificar e apagar layouts de horários. Cada layout é composto
                    por um ou mais componentes, sendo cada componente configurável. Para alterar as configurações
                    de um dado componente, deve carregar no componente a configurar e selecionar a opção "Configuração"
                    no menu lateral.
                </p>
                <h3>Funcionalidades disponíveis</h3>
                <ul className="bulleted-list">
                    <li>Criar um novo Layout.</li>
                    <li>Carregar um Layout externo.</li>
                    <li>Descarregar um Layout.</li>
                    <li>Editar ou Apagar um Layout.</li>
                    <li>Definir o Layout utilizando diversos elementos pré-configurados.</li>
                    <li>Alterar a posição, altura e largura de um dado elemento.</li>
                    <li>Alterar os Parâmetros de um dado elemento.</li>
                    <li>Alterar as Configurações de um dado elemento.</li>
                    <li>Alterar o Estilo de um dado elemento.</li>
                    <li>Remover um dado elemento do Layout.</li>
                    <li>Alterar o número de Layouts mostrados por página.</li>
                </ul>
            </div>
        );
    }
}
export default LayoutConfigMetadata;
